export default __webpack_public_path__ + "static/media/dot-menu.3f2e1799.svg";